// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1fpjm","errors":"Errors_errors__1qvS6"};